<!-- 新房 详情-->
<template>
  <div class="bgBlue">
    <!-- 导航头部组件 -->
    <HeaderNav chooseNav="1"></HeaderNav>
    <!-- 广告 -->
    <div style="height: 100px"></div>
    <div class="add">
      <div class="addBg"><img :src="advertInfo.image" class="img" @click="linkOut(advertInfo.url)" /></div>
    </div>
    <div class="current">
      <div class="item">
        <span class="font-color-gray">当前位置：首页 > 新房 > 楼盘首页 ></span>
        <span>{{ detail.name }}</span>
      </div>
    </div>
    <!-- 楼盘首页 -->
    <div class="saleDetail">
      <div class="title">
        <div :class="isIndex == index ? 'title-items' : 'title-item'" v-for="(item, index) in titleList" :key="index" @click="linkPage(item.url, 'id', id)">
          {{ item.typeName }}
        </div>
      </div>
    </div>
    <div class="saleDetail">
      <div class="news-left">
        <div class="salesImg" v-for="(item, index) in bannerLists" :key="'A' + index"><img :src="item" v-show="index == leftIndex" style="width: 630PX;height: 430PX;" /></div>
        <div class="swiper-container card-carousel-cardes">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide card-carousel-carde"
              style="width: 160px;height: 120px;"
              :class="leftIndex == index ? 'littles' : 'little'"
              v-for="(item, index) in bannerLists"
              :key="'B' + index"
              @click="clickImg(index)"
            >
              <img :src="item" alt="" class="img" />
            </div>
          </div>
        </div>
      </div>
      <div class="sale-right">
        <div class="name">{{ detail.name }}</div>
        <div class="inShou">
          <div class="shou shou-n">{{ detail.saleStatus }}</div>
          <div class="shou" v-for="(item, index) in detail.character" :key="index">{{ item }}</div>
        </div>
        <div class="hs">
          <div class="hui">价格</div>
          <div class="price">
            <p class="big">{{ detail.price }}</p>
            元/m²
          </div>
        </div>
        <div class="hs">
          <div class="hui">开盘</div>
          <div>{{ detail.openStart }}</div>
        </div>
        <div class="hs">
          <div class="hui">交房</div>
          <div>{{ detail.handoverTime }}</div>
        </div>
        <div class="hs">
          <div class="hui">户型</div>
          <div>{{ detail.houseType }}</div>
        </div>
        <div class="hs">
          <div class="hui">地址</div>
          <div>{{ detail.address }}</div>
        </div>
        <div class="more" @click="linkPage('/SaleDetail', 'id', id)">查看更多楼盘详情 ></div>
        <div class="telItem">
          <div class="tel-left">
            <div class="tel-up">
              <div class="tel-img"><img src="../../../static/pC/phone.png" alt="" class="img" /></div>
              <div class="tel-phone">
                <div class="bigg">{{ detail.phoneNumber }} 转 {{ detail.phoneTurnNumber }}</div>
                <div class="lv">安全通话隐藏真实号码，致电售楼处了解更多信息</div>
              </div>
            </div>
            <div class="tel-but">
              <div class="but-left" @click="subscribePhone(detail.name, '预约通话', '')">预约通话</div>
              <div class="but-right" @click="subscribePhone(detail.name, '预约看房', '')">预约看房</div>
            </div>
          </div>
          <div class="tel-right">
            <div class="erweima"><img :src="detail.contactImage" /></div>
            <div class="es">扫码致电售楼部</div>
          </div>
        </div>
      </div>
    </div>
    <div class="adviser">
      <div class="adviser-s">
        <div class="mu-name">销售顾问</div>
        <div class="adviser-a">
          <div class="adviser-i" v-for="(item, index) in thisLists" :key="index">
            <div class="adviser-img"><img :src="item.img" alt="" /></div>
            <div class="adviser-name">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div class="adviser-r">
        <div class="btnswiper next1 next-gray flex-c-c" v-if="flag3"><img src="../../../static/pC/prev.png" /></div>
        <div class="btnswiper next1 next-green flex-c-c" v-else><img src="../../../static/pC/prev.png" /></div>
        <div class="btnswiper prev1 prev-gray flex-c-c" v-if="flag2"><img src="../../../static/pC/prev-1.png" /></div>
        <div class="btnswiper prev1 prev-green flex-c-c" v-else><img src="../../../static/pC/prev-1.png" /></div>
      </div>
    </div>
    <div class="consultant">
      <div class="swiper-container1 card-carousel-cards" style="margin-top: 0;">
        <div class="swiper-wrapper">
          <div class="swiper-slide card-carousel--card" v-for="(item, index) in sellInfo" :key="index">
            <div class="consultant-s">
              <div class="consultant-le" style="margin-right: 20px;"><img :src="item.avatar" alt="" class="imgsw" /></div>
              <div class="consultant-con">
                <div class="consultant-name">{{ item.nickname }}</div>
                <div class="consultant-phone">{{ item.phoneNumber }} 转 {{ item.phoneTurnNumber }}</div>
                <div class="consultant-but">
                  <div class="buts-left" @click="subscribePhone(detail.name, '预约通话', item.id)">预约通话</div>
                  <div class="buts-right" @click="subscribePhone(detail.name, '预约看房', item.id)">预约看房</div>
                </div>
              </div>
              <div class="consultant-ri">
                <div class="eq"><img :src="item.qrCode" style="width: 100%; height: 100%;" /></div>
                <div class="ess">扫码致电顾问</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="activities"><div class="activities-s">特惠活动</div></div>
    <div class="couponItem">
      <div class="coupon" v-for="(item, index) in couponInfo" :key="index" @click="subscribePhone(detail.name, '特惠活动', sellInfo[0].id)">
        <div :class="index == 0 ? 'coupon-up' : index == 1 ? 'coupon-up2' : index == 2 ? 'coupon-up3' : ''">
          <div class="coupon-item">
            <div class="coupon-name">{{ item.name }}</div>
            <div class="coupon-an">{{ item.content }}</div>
            <div class="coupon-song">{{ item.rule }}</div>
          </div>
        </div>
        <div :class="index == 0 ? 'coupon-down' : index == 1 ? 'coupon-down' : index == 2 ? 'coupon-down' : ''">
          <div class="down-le">截止日期：{{ item.expireTime }}</div>
          <div class="down-ri">{{ item.usedAmount }}人报名</div>
        </div>
      </div>
    </div>

    <div class="albums">
      <div class="albums-l">楼盘户型</div>
      <div class="activities-r">
        <div class="activities-l" v-for="(item, index) in houseType" :key="index">
          <div class="text">{{ item.typeName }}</div>
          <div class="xian">|</div>
        </div>
        <div class="more" @click="linkPage('/HouseType', 'id', id)">查看更多 ></div>
      </div>
    </div>
    <div class="albumsImg">
      <div class="albumsItem" v-for="(item, index) in houseInfo" :key="index" style="margin-right: 20px;" @click="saleDetail(item.id)">
        <div class="imgItems"><img :src="item.image" alt="" class="imgsw" /></div>
        <div class="albumsNames">
          <div class="names">{{ item.houseName }}</div>
          <div class="on">{{ item.saleStatus }}</div>
          <div class="zhu" v-if="item.mainPush == 1">主推</div>
          <div class="zhu" v-if="item.mainPush == 0">普通</div>
        </div>
        <div class="jian">建筑面积：{{ item.area }}m²</div>
      </div>
    </div>
    <div class="albums">
      <div class="albums-l">楼盘相册</div>
      <div class="activities-r">
        <div class="activities-l" v-for="(item, index) in albumType" :key="index" @click="linkBuildImgType(item.id)">
          <div class="text">{{ item.typeName }}</div>
          <div class="xian">|</div>
        </div>
        <div class="more" @click="linkPage('/BuildImg', 'id', id)">查看更多 ></div>
      </div>
    </div>
    <div class="albumsImg">
      <div class="albumsItem" v-for="(item, index) in albumType" :key="index">
        <div class="imgItem"><img :src="item.image" alt="" class="imgsw" /></div>
        <div class="albumsName">{{ item.typeName }}</div>
      </div>
    </div>
    <div class="albums">
      <div class="albums-l">特价房源</div>
      <!-- <div class="activities-r"><div class="more">查看更多 ></div></div> -->
    </div>
    <div class="special">
      <div class="specialItem" v-for="(item, index) in discountHouse" :key="index">
        <div class="special-left">
          <div class="special-title">{{ item.name }} 建面{{ item.houseArea }}m²</div>
          <div class="special-content">
            <div class="te">特价</div>
            <div class="wan">{{ item.discountPrice }}万</div>
            <div class="yuan">原价{{ item.totalPrice }}万</div>
            <div class="li">立省{{ item.diffPrice }}万</div>
          </div>
          <div class="over">
            <!-- 倒计时 -->
            <CountDown :curStartTime="item.endTime"></CountDown>
          </div>
        </div>
        <div class="special-right" @click="subscribePhone(item.name, '抢特价', '')">抢特价</div>
      </div>
    </div>
    <div class="albumse">
      <div class="albumse-left">
        <div class="albums-l">楼盘动态</div>
        <div class="activities-r"><div class="more" @click="linkPage('/Dynamics', 'id', id)">查看更多 ></div></div>
      </div>
      <div class="albumse-right">
        <div class="albums-l">用户点评</div>
        <div class="activities-r"><div class="more" @click="linkPage('/evaluate', 'id', id)">查看更多 ></div></div>
      </div>
    </div>
    <div class="dynamic">
      <div class="dynamic-left">
        <div class="detailItems" v-for="(item, index) in articleInfo" :key="index" v-if="articleInfo.length > 0" @click="linkMessageDetail(item.id)">
          <div class="detail-left"><img :src="item.avatar" class="img" /></div>
          <div class="detail-right">
            <div class="detail-name">{{ item.title }}</div>
            <div class="content" v-html="item.content"></div>
            <!-- <div style="color:#345c4e;font-size: 14px;">【查看详情】</div> -->
            <div class="time">{{ item.publishTime }}</div>
          </div>
        </div>
        <div v-if="articleInfo.length == 0" class="flex-c-c" style="height: 255px;">暂无数据, 敬请期待</div>
      </div>
      <div class="dynamic-right">
        <div class="commentItem" v-for="(item, index) in commentInfo" :key="index" v-if="commentInfo.length > 0">
          <div class="comment-left"><img :src="item.avatar" class="img" /></div>
          <div class="comment-right">
            <div class="detail-phone">{{ item.phone }}</div>
            <div class="detail-content" v-html="item.content"></div>
            <div class="time">{{ item.commentTime }}</div>
          </div>
        </div>
        <div v-if="commentInfo.length == 0" class="flex-c-c" style="height: 255px;">暂无数据, 敬请期待</div>
      </div>
    </div>
    <div class="albums">
      <div class="albums-l">周边配套</div>
      <!-- <div class="activities-r"><div class="more">查看更多周边配套 ></div></div> -->
    </div>
    <div class="zhoubian flex-b-s">
      <div id="map" style="width:60%;height:500px;"></div>
      <div class="">
        <div class="flex-s-c map-icon-list">
          <div class="flex-c-c-fd map-icon-item" @click="chooseType('公交')">
            <img src="../../../static/pC/map01.png" />
            <div>公交</div>
          </div>
          <div class="flex-c-c-fd map-icon-item" @click="chooseType('地铁')">
            <img src="../../../static/pC/map02.png" />
            <div>地铁</div>
          </div>
          <div class="flex-c-c-fd map-icon-item" @click="chooseType('医院')">
            <img src="../../../static/pC/map03.png" />
            <div>医院</div>
          </div>
          <div class="flex-c-c-fd map-icon-item" @click="chooseType('学校')">
            <img src="../../../static/pC/map04.png" />
            <div>学校</div>
          </div>
          <div class="flex-c-c-fd map-icon-item" @click="chooseType('商业')">
            <img src="../../../static/pC/map05.png" />
            <div>商业</div>
          </div>
          <div class="flex-c-c-fd map-icon-item" @click="chooseType('景区')">
            <img src="../../../static/pC/map06.png" />
            <div>景区</div>
          </div>
        </div>
        <div class="map-around">附近共有{{ maskerList.length }}个{{ type }}</div>
        <div class="map-scoll">
          <div class="map-list">
            <div class="map-list-item flex-b-s " v-for="(item, index) in maskerList" :key="index">
              <div>{{ index + 1 }}</div>
              <div style="max-width: 60%;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 1;overflow: hidden;  " class="ellipsis-one">{{ item.title }}</div>
              <div>{{ item.Distance }}米</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 楼盘推荐 -->
    <div class="recommend">
      <div class="t flex-b-c">
        <div>楼盘推荐</div>
        <!-- 导航按钮 -->
        <div class="flex-c-c swiper-button-group">
          <div class="btnswiper next next-gray flex-c-c" v-if="flag1"><img src="../../../static/pC/prev.png" /></div>
          <div class="btnswiper next next-green flex-c-c" v-else><img src="../../../static/pC/prev.png" /></div>
          <div class="btnswiper prev prev-gray flex-c-c" v-if="flag"><img src="../../../static/pC/prev-1.png" /></div>
          <div class="btnswiper prev prev-green flex-c-c" v-else><img src="../../../static/pC/prev-1.png" /></div>
        </div>
      </div>

      <div class="swiper-container card-carousel-cards">
        <div class="swiper-wrapper">
          <div class="swiper-slide card-carousel--card" v-for="(item, index) in recommendList" :key="index" @click="getDetail(item.id)">
            <img :src="item.avatar" />
            <div class="n">{{ item.name }}</div>
            <div class="money">{{ item.price }}元/㎡</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 通知表单 -->
    <SanTable :maskShow="maskShow" :houseName="houseName" :whereFrom="whereFrom" :sellId="sellId"></SanTable>

    <!-- 右侧导航 -->
    <RightNav></RightNav>

    <!-- 脚步导航组件 -->
    <FooterNav></FooterNav>
  </div>
</template>

<script>
import HeaderNav from '../../components/HeaderNav';
import FooterNav from '../../components/FooterNav';
import Banners from '../../components/Banners.vue';
import SanTable from '../../components/SanTable.vue';
import RightNav from '../../components/RightNav.vue';
import CountDown from '../../components/CountDown.vue';
import { apiGetEstateHome, apiChangeOther, apiAddNotes, apiGetLocation } from '../../api/job.js';
import { apigetSetting } from '../../api/login.js';
export default {
  name: 'Index',
  components: {
    HeaderNav: HeaderNav,
    FooterNav: FooterNav,
    Banners: Banners,
    SanTable: SanTable,
    RightNav: RightNav,
    CountDown: CountDown
  },
  data() {
    return {
      isIndex: 0,
      titleList: [
        { typeName: '楼盘首页', url: '/jobDetail' },
        { typeName: '楼盘详情', url: '/SaleDetail' },
        { typeName: '楼盘相册', url: '/BuildImg' },
        { typeName: '户型介绍', url: '/HouseType' },
        { typeName: '用户点评', url: '/evaluate' },
        // { typeName: '周边配套', url: '' },
        { typeName: '楼盘动态', url: '/Dynamics' }
      ],
      estateInfo: '',

      flag: false, //导航按钮是否到最末尾
      flag1: true, //导航按钮是否到最开头

      bannerLists: [],
      leftIndex: 0,

      maskShow: false, //通知表单--是否打开
      houseName: '', //通知表单--房子名称
      whereFrom: '', //通知表单--来源
      sellId: '', //通知表单--销售顾问Id

      advertInfo: {}, //广告
      detail: {}, //详情
      sellInfo: [], //销售顾问--列表
      thisLists: [
        { img: '../../../static/pC/dui.png', name: '直属开发商' },
        { img: '../../../static/pC/dui.png', name: '售楼处接待' },
        { img: '../../../static/pC/dui.png', name: '不赚差价' }
      ], //销售顾问--小标题
      flag2: false, //销售顾问--导航按钮是否到最末尾
      flag3: true, //销售顾问--导航按钮是否到最开头
      couponInfo: [], //优惠券列表

      albumType: [], //楼盘相册列表
      houseInfo: [], //楼盘户型
      houseType: [], //楼盘户型--类型
      discountHouse: [], //特价房源
      articleInfo: [], //楼盘动态
      commentInfo: [], //用户点评
      recommendList: [], //推荐楼盘
      longitude: '', //经纬度
      latitude: '', //经纬度
      type: '公交', //地图类型
      maskerList: [],

      login: false, //是否登录
      userInfo: [], //是否登录--用户信息
      id: ''
    };
  },
  created(options) {
    this.id = this.$route.query.id;
    this.judgeLogin();
    this.getDetail(this.id);
  },
  mounted() {
    window.addEventListener('scroll', this.showbtn, true);
  },
  methods: {
    //地图 -- 初始化
    init() {
      let address = '';
      let t = this;
      var center = new qq.maps.LatLng(Number(t.latitude), Number(t.longitude)); //地图中心点

      var map = new qq.maps.Map(document.getElementById('map'), {
        //地图重置
        center: center,
        zoom: 13,
        disableDefaultUI: true
      });

      var infoWin = new qq.maps.InfoWindow({
        map: map
      });
      for (let i = 0; i < this.maskerList.length; i++) {
        //标记点
        var marker = new qq.maps.Marker({
          position: new qq.maps.LatLng(t.maskerList[i].location.lat, t.maskerList[i].location.lng),
          map: map
        });
        marker.libraryName = this.maskerList[i].title;
        marker.distance = this.maskerList[i].Distance;
        qq.maps.event.addListener(marker, 'click', function() {
          infoWin.open();
          infoWin.setContent('<div style="text-align:center;white-space:' + 'nowrap;margin:10px; "> ' + this.libraryName + '距离' + this.distance + '米' + ' </div>');
          infoWin.setPosition(new qq.maps.LatLng(Number(t.maskerList[i].location.lat), Number(t.maskerList[i].location.lng))); //提示窗位置
        });
      }
      var anchor = new qq.maps.Point(300, 0),
        size = new qq.maps.Size(600, 680),
        origin = new qq.maps.Point(-150, 0),
        markerIcon = new qq.maps.MarkerImage('../../static/pC/phone.png', size, origin, anchor);
      // let icon1 = new qq.maps.MarkerImage('static/pC/phone.png', size, origin, anchor)
      // marker.setIcon(icon1);

      var marker = new qq.maps.Marker({
        position: center,
        map: map
      });
    },

    //地图 -- 获取附近相关经纬度
    getLocation() {
      let t = this;
      var url =
        'https://apis.map.qq.com/ws/place/v1/search?boundary=nearby(' +
        t.latitude +
        ',' +
        t.longitude +
        ',1000)&keyword=' +
        t.type +
        '&page_size=10&page_index=1&key=DCBBZ-XKGKR-YVMWA-W77YC-4G2GV-CDFNI';
      apiGetLocation({
        mapUrl: url
      }).then(res => {
        if (res.success) {
          this.maskerList = res.data;
          this.init();
        } else {
          this.$message({ message: res.msg, type: 'error' });
        }
      });
    },

    //地图 -- 切换
    chooseType(n) {
      this.type = n;
      this.getLocation();
    },

    //跳转到外部链接
    linkOut(url) {
      if (url.includes('https://') || url.includes('http://')) {
        window.location.href = url;
      } else {
        window.location.href = `https://${url}`;
      }
    },

    //获取详情
    getDetail(id) {
      var id = id;
      let _this = this;
      this.backtop();
      apiGetEstateHome({ id: id }).then(res => {
        if (res.success) {
          this.estateInfo = res.data.estateInfo;
          this.bannerLists = res.data.estateInfo.album;
          this.advertInfo = res.data.advertInfo; //广告
          this.detail = res.data.estateInfo; //详情
          this.sellInfo = res.data.userInfo; //销售顾问列表
          this.couponInfo = res.data.couponInfo; //特惠活动列表
          this.albumType = res.data.albumType; //楼盘相册列表
          this.houseInfo = res.data.houseInfo; //楼盘户型
          this.houseType = res.data.houseType; //楼盘户型--类型
          this.discountHouse = res.data.discountHouse; //特价房源
          this.articleInfo = res.data.articleInfo; //楼盘动态
          this.commentInfo = res.data.commentInfo.list; //用户点评
          this.recommendList = res.data.recommendList; //推荐楼盘

          this.longitude = res.data.estateInfo.longitude;
          this.latitude = res.data.estateInfo.latitude;

          sessionStorage.setItem('houseDetail', JSON.stringify(res.data.estateInfo));

          this.getLocation();

          this.$nextTick(() => {
            //等页面刷新完之后，再执行回调函数中的方法
            var swiper = new Swiper('.swiper-container', {
              slidesPerView: 4,
              spaceBetween: 20,
              loop: false,
              navigation: {
                nextEl: '.prev',
                prevEl: '.next'
              },
              on: {
                slideChangeTransitionEnd: function() {
                  if (this.isEnd) {
                    _this.flag = true;
                  } else {
                    _this.flag = false;
                  }
                  if (this.isBeginning) {
                    _this.flag1 = true;
                  } else {
                    _this.flag1 = false;
                  }
                }
              }
            });
            //销售顾问
            var swiper1 = new this.Swiper('.swiper-container1', {
              slidesPerView: 2, //一行显示2个
              spaceBetween: 20,
              loop: false,
              navigation: {
                nextEl: '.prev1',
                prevEl: '.next1'
              },
              on: {
                slideChangeTransitionEnd: function() {
                  if (this.isEnd) {
                    _this.flag2 = true;
                  } else {
                    _this.flag2 = false;
                  }
                  if (this.isBeginning) {
                    _this.flag3 = true;
                  } else {
                    _this.flag3 = false;
                  }
                }
              }
            });
          });
        } else {
          this.$message({ message: res.msg, type: 'error' });
        }
      });
    },

    //点击预约通话、预约看房
    subscribePhone(n, type, sellId) {
      // 是否要先登录才能打开通知弹窗
      apigetSetting({}).then(res => {
        if (res.success) {
          var isLoginOpenSanTable = res.data.list.isLogin; //1=》需要，0=》不需要
          if (isLoginOpenSanTable == 0) {
            this.houseName = n;
            this.whereFrom = type;
            this.sellId = sellId;
            this.maskShow = true;
          } else if(isLoginOpenSanTable == 1 ){
            if (this.login == true || this.login == 'true') {
              this.houseName = n;
              this.whereFrom = type;
              this.sellId = sellId;
              this.maskShow = true;
            } else {
              this.$message({ message: '请先登录', type: 'error' });
            }
          }
        } else {
          this.$message({ message: res.msg, type: 'error' });
        }
      });
    },

    //关闭通知弹窗
    closeSanTable() {
      this.maskShow = false;
    },

    //判断是否登录
    judgeLogin() {
      if (sessionStorage.getItem('login') != null && sessionStorage.getItem('login') != '') {
        this.login = sessionStorage.getItem('login');
        if (sessionStorage.getItem('userInfo') != null && sessionStorage.getItem('userInfo') != '') {
          var userInfo = sessionStorage.getItem('userInfo');
          this.userInfo = JSON.parse(userInfo);
        }
      }
    },

    //banner
    clickImg(index) {
      this.leftIndex = index;
    },

    //返回顶部
    backtop() {
      var timer = setInterval(function() {
        let osTop = document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
        this.isTop = true;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    },

    //头部跳转页面
    linkDetail(index) {
      this.isIndex = index;
      if (this.isIndex == 0) {
        this.$router.push({ path: '/jobDetail' });
      }
      if (this.isIndex == 1) {
        this.$router.push({ path: '/SaleDetail' });
      }
      if (this.isIndex == 2) {
        this.$router.push({ path: '/BuildImg' });
      }
      if (this.isIndex == 3) {
        this.$router.push({ path: '/HouseType' });
      }
      if (this.isIndex == 4) {
        this.$router.push({ path: '/HouseType' });
      }
      if (this.isIndex == 6) {
        this.$router.push({ path: '/Dynamics' });
      }
    },

    //跳转页面    url:  页面地址  parame:  参数 key：参数值
    linkPage: function(url, id, key) {
      if (id == '') {
        this.$router.push({ path: url });
      } else {
        this.$router.push({ path: url, query: { id: key } });
      }
    },

    //跳转到户型类型
    saleDetail(id){
      this.$router.push({ path: "/HouseTypeDetail" , query: { id:this.id, typeId:id }});
    },

    //跳转到相册类型
    linkBuildImgType: function(id) {
      let type = id;
      console.log(type);
      this.$router.push({ path: '/BuildImgType', query: { id: this.id, type: type } });
    },

    //跳转到楼盘资讯
    linkMessageDetail: function(id){
      this.$router.push({ path: '/messageDetail', query: { id: id } });
    },


  }
};
</script>
<style scoped>
/* 地图 */
.map-icon-list {
}
.map-icon-list .map-icon-item {
  padding: 10px;
  cursor: pointer;
}
.map-icon-list .map-icon-item img {
  width: 50px;
  height: 50px;
}
.map-around {
  margin-top: 10px;
  background-color: #f5f5f5;
}

.map-scoll {
  width: 450px;
  height: 350px;
  margin: 20px 0;
  border: 1px solid #a4a8bb;
  overflow: hidden;
}
.map-scoll .map-list {
  width: 450px;
  height: 500px;
  overflow: scroll;
}
.map-scoll .map-list .map-list-item {
  width: 450px;
  padding: 5px 20px;
  margin-bottom: 1px solid #cccccc;
}
.map-scoll .map-list .map-list-item div {
  display: inline-block;
}

/* 广告 */
.add {
  padding: 0;
  max-width: 1200px;
  margin: 0 auto;
}
.addBg {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}
.addBg .img {
  width: 100%;
}
/* 当前 */
.current {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background-color: #fafafa;
  margin-top: 30px;
  border-bottom: 1px solid #e5e5e5;
}
.current .item {
  max-width: 1200px;
  margin: 0 auto;
  font-size: 14px;
}
/* 楼盘详情 */
.saleDetail {
  max-width: 1200px;
  margin: 30px auto 0 auto;
  display: flex;
}
.saleDetail .title {
  width: 100%;
  background-color: #345c4e;
  color: #fff;
  display: flex;
  align-items: center;
  height: 50px;
}
.saleDetail .title .title-item {
  width: 130px;
  text-align: center;
  cursor: pointer;
}
.saleDetail .title .title-items {
  width: 130px;
  text-align: center;
  background-color: #a98c60;
  height: 50px;
  line-height: 50px;
  cursor: pointer;
}
.detailItem {
  width: 630px;
  height: 430px;
}
.news-left {
  width: 630px;
}
.saleImg {
  width: 630px;
  white-space: nowrap;
  overflow-y: hidden;
  overflow-x: scroll;
  display: flex;
}
::-webkit-scrollbar {
  display: none;
}
.saleImg .little {
  padding: 0;
}
.saleImg .little .img {
  width: 160px;
  height: 120px;
  margin-right: 10px;
  margin-top: 10px;
}
.sale-right {
  padding: auto;
  margin-left: 30px;
}
.sale-right .name {
  font-size: 30px;
  font-weight: bold;
}
.sale-right .inShou {
  margin: 10px 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.sale-right .inShou .shou {
  margin-right: 10px;
  margin-bottom: 10px;
  padding: 2px 6px;
  background: #f5f5f5;
  color: #999999;
}
.sale-right .inShou .shou-n {
  background: rgba(169, 140, 96, 0.3);
  color: #a98c60;
}
.sale-right .hs {
  display: flex;
  align-items: center;
  margin-top: 15px;
}
.sale-right .hs .hui {
  color: #999999;
  margin-right: 20px;
}
.sale-right .hs .price {
  display: flex;
  align-items: center;
  color: #345c4e;
}
.sale-right .hs .price .big {
  font-size: 30px;
}
.sale-right .more {
  margin: 30px 0;
  color: #345c4e;
  cursor: pointer;
}
.telItem {
  width: 530px;
  /* height: 180px; */
  display: flex;
  padding: 20px;
  background-color: #eaeeed;
}
.telItem .tel-left {
  padding: 0;
}
.telItem .tel-left .tel-up {
  display: flex;
  align-items: center;
}
.telItem .tel-left .tel-up .bigg {
  font-size: 30px;
  color: #345c4e;
}
.telItem .tel-left .tel-up .lv {
  margin-top: 15px;
  font-size: 14px;
  color: #345c4e;
}
.telItem .tel-left .tel-but {
  display: flex;
  align-items: center;
  justify-content: center;
}
.telItem .tel-left .but-left {
  background-color: #345c4e;
  color: #fff;
  width: 120px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  border-radius: 10px;
  margin-top: 20px;
  cursor: pointer;
}
.telItem .tel-left .but-right {
  background-color: #a98c60;
  color: #fff;
  width: 120px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  border-radius: 10px;
  margin-left: 30px;
  margin-top: 20px;
  cursor: pointer;
}
.tel-right {
  margin-left: 20px;
  text-align: center;
}
.erweima {
  width: 100px;
  height: 100px;
  border: 1px solid #345c4e;
}
.erweima img {
  width: 100%;
  height: 100%;
}
.es {
  font-size: 14px;
  margin-top: 20px;
}
.adviser {
  max-width: 1200px;
  margin: 50px auto 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.adviser-s {
  display: flex;
  margin: 20px 0;
}
.adviser-s .mu-name {
  font-size: 22px;
  font-weight: bold;
}
.adviser-a {
  display: flex;
  margin-left: 20px;
}
.adviser-i {
  display: flex;
  align-items: center;
  margin-left: 20px;
}
.adviser-img {
  margin-right: 20px;
}
.adviser-r {
  display: flex;
  align-items: center;
}
.adviser-r .btnswiper {
  width: 30px;
  height: 30px;
}
.adviser-r .btnswiper img {
  width: 12px;
  height: 20px;
}
.adviser-r .btnswiper img {
  width: 12px;
  height: 20px;
}
.adviser-r .prev1 {
  margin-left: 20px;
}
.adviser-r .next-gray {
  background: #e5e5e5;
}
.adviser-r .next-green {
  background: #345c4e;
}
.adviser-r .prev-gray {
  background: #e5e5e5;
}
.adviser-r .prev-green {
  background: #345c4e;
}

.le {
  margin-right: 10px;
}
.consultant {
  width: 1200px;
  margin: 0 auto;
  border: 1px solid #e5e5e5;
  padding: 20px;
  display: flex;
  justify-content: space-between;
}
.consultant-con {
  margin-left: 10px;
}
.consultant-s {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.consultant-le {
  width: 120px;
  height: 120px;
}
.consultant-s .consultant-le .imgsw {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  margin-right: 20px;
}

.consultant-con {
  font-size: 18px;
}
.consultant-phone {
  font-size: 24px;
  margin: 5px 0;
}
.consultant-but {
  display: flex;
  align-items: center;
}
.buts-left {
  background-color: #345c4e;
  width: 100px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #fff;
  border-radius: 8px;
  font-size: 16px;
}
.buts-right {
  background-color: #a98c60;
  width: 100px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #fff;
  border-radius: 8px;
  margin-left: 10px;
  font-size: 16px;
}
.consultant-ri {
  margin-left: 20px;
}
.eq {
  width: 90px;
  height: 90px;
  border: 1px solid #345c4e;
  margin: 0 auto;
}
.consultant-ri .eq img {
  width: 88px;
  height: 88px;
}
.ess {
  margin-top: 10px;
  font-size: 14px;
}

.activities {
  width: 1200px;
  margin: 50px auto 0 auto;
}
.activities-s {
  font-size: 22px;
  font-weight: bold;
  margin: 30px 0;
}
.couponItem {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
}
.coupon {
  width: 32%;
  padding: 0 10px;
}
.coupon-up {
  width: 100%;
  height: 173px;
  background-image: url('../../../static/pC/1-1-2.png');
  background-size: 100% 100%;
}
.coupon-up2 {
  width: 100%;
  height: 173px;
  background-image: url('../../../static/pC/1-1-1.png');
  background-size: 100% 100%;
}
.coupon-up3 {
  width: 100%;
  height: 173px;
  background-image: url('../../../static/pC/1-1-3.png');
  background-size: 100% 100%;
}
.coupon-item {
  padding: 0;
}
.coupon-name {
  color: #fff;
  font-size: 30px;
  padding: 20px 0 0 20px;
}
.coupon-an {
  color: #fff;
  font-size: 16px;
  padding: 5px 0 0 20px;
}
.coupon-song {
  /* color: #fff; */
  font-size: 16px;
  padding: 30px 0 0 20px;
}
.coupon-down {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
  color: #fc624f;
  font-size: 16px;
}
.coupon-down2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
  color: #f87722;
  font-size: 16px;
}
.coupon-down3 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
  color: #8802d6;
  font-size: 16px;
}
.albums {
  width: 1200px;
  margin: 30px auto 20px auto;
  display: flex;
  justify-content: space-between;
}
.albums-l {
  font-size: 20px;
  font-weight: bold;
}
.activities-r {
  display: flex;
}
.activities-l {
  display: flex;
  color: #345c4e;
  font-size: 15px;
  cursor: pointer;
}
.more {
  font-size: 14px;
  color: #666;
  cursor: pointer;
}
.xian {
  margin: 0 20px;
}
.albumsImg {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.albumsItem {
  width: 25%;
  padding: 0;
  text-align: center;
}
.albumsItem:last-child {
  margin-right: 0;
}
.imgItem {
  width: 280px;
  height: 220px;
}
.imgItems {
  width: 280px;
  height: 280px;
  border: 1px solid #e5e5e5;
}
.imgsw {
  width: 100%;
  height: 100%;
}
.albumsName {
  margin-top: 20px;
}
.albumsNames {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
.names {
  font-size: 16px;
  font-weight: bold;
}
.on {
  padding: 0px 5px;
  margin-left: 10px;
  color: #a98c60;
  background-color: #e4dbce;
  font-size: 12px;
}
.zhu {
  padding: 0px 5px;
  margin-left: 5px;
  color: #345c4e;
  border: 1px solid #345c4e;
  font-size: 12px;
}
.jian {
  font-size: 14px;
  margin-top: 10px;
}
.special {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.specialItem {
  width: 585px;
  padding: 20px;
  margin-bottom: 30px;
  border: 1px solid #e5e5e5;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.special-left {
  padding: 0;
}
.special-title {
  font-size: 26px;
}
.special-content {
  display: flex;
  align-items: center;
}
.te {
  font-size: 24px;
}
.wan {
  font-size: 26px;
  color: #a98c60;
  margin-right: 10px;
}
.yuan {
  text-decoration: line-through;
  font-size: 24px;
  color: #999;
  margin-right: 10px;
}
.li {
  font-size: 22px;
  border: 1px solid #a98c60;
  padding: 0 10px;
  color: #a98c60;
}
.over {
  font-size: 24px;
  color: #a98c60;
}
.special-right {
  font-size: 16px;
  color: #fff;
  background-color: #a98c60;
  width: 110px;
  height: 40px;
  line-height: 40px;
  border-radius: 8px;
  text-align: center;
}
.albumse {
  width: 1200px;
  margin: 30px auto 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.albumse-left {
  width: 49%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;
}
.albumse-right {
  width: 49%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;
}
.dynamic {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.detailItems {
  display: flex;
  padding: 0 0 20px 0;
}
.dynamic-left {
  width: 49%;
  min-height: 522px;
  border: 1px solid #e5e5e5;
  padding: 30px 15px 10px 15px;
}
.detailItems .detail-left {
  width: 200px;
  height: 140px;
}
.detailItems .detail-left .img {
  width: 100%;
  height: 100%;
}
.detailItems .detail-right {
  margin-left: 20px;
}
.detailItems .detail-right .detail-name {
  font-size: 18px;
}
.detailItems .detail-right .content {
  padding: 20px 0;
  font-size: 14px;
}
.detailItems .detail-right .time {
  font-size: 14px;
  color: #a4a8bb;
}
.dynamic-right {
  width: 49%;
  min-height: 522px;
  border: 1px solid #e5e5e5;
  padding: 0;
}
.commentItem {
  display: flex;
  margin-top: 30px;
  padding: 0 20px 33px 20px;
  border-bottom: 1px solid #e5e5e5;
}
.comment-left {
  width: 60px;
  height: 60px;
}
.comment-left img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
.comment-right {
  margin-left: 20px;
}
.detail-content {
  margin-top: 20px;
}
.detail-content img{
  max-width: 100%;
}
.time {
  font-size: 14px;
  color: #a4a8bb;
  margin-top: 20px;
}
.zhoubian {
  width: 1200px;
  margin: 0 auto;
}
.zhou-img {
  width: 1200px;
  height: 400px;
}
/* 楼盘推荐 */
.recommend {
  max-width: 1200px;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 50px;
}
.recommend .t {
  width: 100%;
  font-size: 22px;
  font-weight: bold;
}
.recommend .swiper-button-group {
}
.recommend .swiper-button-group .btnswiper {
  width: 30px;
  height: 30px;
}
.recommend .swiper-button-group .btnswiper img {
  width: 12px;
  height: 20px;
}
.recommend .swiper-button-group .prev {
  margin-left: 20px;
}
.recommend .swiper-button-group .next-gray {
  background: #e5e5e5;
}
.recommend .swiper-button-group .next-green {
  background: #345c4e;
}
.recommend .swiper-button-group .prev-gray {
  background: #e5e5e5;
}
.recommend .swiper-button-group .prev-green {
  background: #345c4e;
}
.card-carousel-cards {
  display: flex;
  transition: transform 150ms ease-out;
  transform: translatex(0px);
  margin-top: 40px;
}
.card-carousel-cards .card-carousel--card {
  cursor: pointer;
  background-color: #fff;
  z-index: 3;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.swiper-container .card-carousel-cards .card-carousel--card:hover {
  /* box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.1); */
}
.card-carousel-cards .card-carousel--card:first-child {
  margin-left: 0;
}
.card-carousel-cards .card-carousel--card:last-child {
  margin-right: 0;
}
.card-carousel-cards .card-carousel--card img {
  max-width: 100%;
  height: 227px;
  vertical-align: bottom;
  display: flex;
}
.swiper-container .card-carousel-cards .card-carousel--card img:hover {
  /* opacity: 0.5; */
}
.card-carousel-cards .card-carousel--card .n {
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  margin-top: 20px;
}
.card-carousel-cards .card-carousel--card .money {
  font-size: 16px;
  font-weight: bold;
  color: #345c4e;
  margin-top: 20px;
}

.swiper-container1 {
  width: 100%;
  /* height: 236px; */
  margin-left: auto;
  margin-right: auto;
  overflow: hidden;
}

.card-carousel-cardes {
  display: flex;
  transition: transform 150ms ease-out;
  transform: translatex(0px);
  margin-top: 40px;
}

.card-carousel-cardes .card-carousel-carde {
  cursor: pointer;
  background-color: #fff;
  z-index: 3;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.card-carousel-cardes .card-carousel-carde:hover {
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.1);
}
.card-carousel-cardes .card-carousel-carde:first-child {
  margin-left: 0;
}
.card-carousel-cardes .card-carousel-carde:last-child {
  margin-right: 0;
}
.card-carousel-cardes .card-carousel-carde img {
  max-width: 100%;
  height: 120px;
  vertical-align: bottom;
  display: flex;
}
.card-carousel-cardes .card-carousel-carde img:hover {
  opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// src/view/Job/Detail.vue